import { apiService } from './api';
import {
  ReportSection,
  ReportSectionCreate,
  ReportSectionUpdate,
} from '../types';

export class ReportSectionsService {
  async list(createdById?: string): Promise<ReportSection[]> {
    const qs = createdById ? `?created_by_id=${encodeURIComponent(createdById)}` : '';
    return apiService.get<ReportSection[]>(`/reports/sections-library${qs}`);
  }

  async getById(id: string): Promise<ReportSection> {
    return apiService.get<ReportSection>(`/reports/sections-library/${id}`);
  }

  async create(payload: ReportSectionCreate): Promise<ReportSection> {
    return apiService.post<ReportSection>('/reports/sections-library', payload);
  }

  async update(id: string, payload: ReportSectionUpdate): Promise<ReportSection> {
    return apiService.put<ReportSection>(`/reports/sections-library/${id}`, payload);
  }

  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`/reports/sections-library/${id}`);
  }
}

export const reportSectionsService = new ReportSectionsService();
